import { useEffect, useState } from "react";
// import "./FilterableTable.css"

import { getInputBoxFromType } from "../../../services/editTable";
import AllOneTable from "../Sort-Filter-Edit/SortFilterEditTableStyle.module.css";

import { FaEdit } from "react-icons/fa";
import { FaPrescriptionBottleAlt } from "react-icons/fa";

//Icon
import { FaPlus } from "react-icons/fa";
import { FaRegTrashAlt } from "react-icons/fa";
import { FaUpload } from "react-icons/fa";
import { FaDownload } from "react-icons/fa";

const SortFilterEdit = ({
  data,
  columns,
  filterableCols,
  sortableCols,
  tableHeader,
  recordsPerPageOption,
  defaultRecordPerPage,
  uniqueId,
}) => {
  const [tabData, setTabData] = useState(data);
  const [sortedColumn, setSortedColumn] = useState("");
  const [sortedAsc, setSortedAsc] = useState(0);
  const [valuesToBeFiltered, setValuesToBeFiltered] = useState();
  const [filterableColumn, setFilterableColumn] = useState(
    columns.filter((col) => col.filterable)
  );
  // const [filterStrings, setFilterString] = useState();

  const [recordsPerPage, setRecordsPerPage] = useState(defaultRecordPerPage);

  const [pages, setPages] = useState(Math.ceil(data.length / recordsPerPage));
  const [pageNo, setPageNo] = useState(1);
  const [pageStartIndex, setPageStartIndex] = useState(0);
  const [pageEndIndex, setPageEndIndex] = useState(recordsPerPage - 1);
  const [datainPage, setDatainPage] = useState(
    data.filter((item, index) => index < recordsPerPage)
  );
  const [selectedOneRowForEdit, setSelectedOneRowForEdit] = useState();
  const [selectedOneRowForDelete, setSelectedOneRowForDelete] = useState();

  useEffect(() => {
    let filteredTempObj = {};
    filterableCols.forEach((elemt) => {
      if (elemt.filterable) {
        filteredTempObj[elemt.column] = "";
      }
    });

    setValuesToBeFiltered(filteredTempObj);
  }, []);

  // useEffect(() => {

  //   let filteredData = data.filter((itemRow) => {

  //     let dataPresentInRow = true;
  //     columns.every((cols, index) => {

  //       let columnName = cols.column;
  //       console.log(columnName)
  //       let columnData = itemRow[columnName].toString();
  //       console.log(columnData);

  //       if (cols.filterable && !columnData.includes(valuesToBeFiltered[columnName])) {
  //         dataPresentInRow = false
  //         return false;
  //       }
  //     })

  //     return dataPresentInRow;

  //     // return filterableColumn.some((colName, index) =>
  //     //   itemRow[colName].includes(valuesToBeFiltered[colName])
  //     // );
  //   });

  //   setTabData([...filteredData]);
  // }, [valuesToBeFiltered, filterableColumn, tabData]);

  const changeFilterableInputs = (e) => {
    const { name, value } = e.target;

    let tempFilteredStringObject = { ...valuesToBeFiltered, [name]: value };

    console.log(tempFilteredStringObject);
    // filterLogic to be implemented here

    let filteredData = data.filter((itemRow) => {
      let dataPresentInRow = true;
      columns.forEach((cols, index) => {
        let columnName = cols.column;

        let columnData = itemRow[columnName].toString();

        if (
          cols.filterable &&
          tempFilteredStringObject[columnName] !== "" &&
          !columnData.includes(tempFilteredStringObject[columnName])
        ) {
          console.log(tempFilteredStringObject[columnName], columnData);
          dataPresentInRow = false;
        }
      });

      return dataPresentInRow;

      // return filterableColumn.some((colName, index) =>
      //   itemRow[colName].includes(valuesToBeFiltered[colName])
      // );
    });

    setTabData([...filteredData]);
    let start = 0;
    let end = Math.min(recordsPerPage - 1, filteredData.length - 1);

    console.log(filteredData);

    let tempDataArray = [];
    for (let index = start; index <= end; index++) {
      tempDataArray.push(filteredData[index]);
    }

    // setRecordsPerPage(recordsPerPage);
    setPages(Math.ceil(data.length / recordsPerPage));
    setPageNo(1);
    setDatainPage(tempDataArray);

    console.log(tempDataArray);

    setValuesToBeFiltered(tempFilteredStringObject);
    // console.log({ ...valuesToBeFiltered, [name]: value })
    // console.log(e.target.name, e.target.value)
  };

  // const PopUp = ({ filterableColumns }) => {
  //   // console.log("popv b", filterableColumns)
  //   filterableCols.forEach(element => {
  //     console.log(element)
  //   });

  //   return <div className={"popup " + true ? "showpopup" : "hidepopup"}>
  //     <button onClick={() => closePopup()}>close</button>
  //     <div>        {
  //       filterableColumns.map((oneCol) =>
  //         <div><span>{oneCol.column} : </span><input value={oneCol.column} /></div>

  //       )
  //     }</div>

  //   </div>

  // }

  // const closePopup = () => {
  //   setPopupVisibility(!popupVisibility);
  // }

  // const sortColumn = (col, asc) => {

  //   if (asc) {
  //     setSortedAsc(1);
  //   }
  //   else {
  //     setSortedAsc(-1);
  //   }

  //   if (sortedColumn !== col) {

  //     setSortedAsc(1);
  //     setSortedColumn(col);
  //   }
  //   let sortedData = asc
  //     ? data.sort((row1, row2) => (row1[col] > row2[col]) ? 1 : (row1[col] < row2[col]) ? -1 : 0)
  //     : data.sort((row1, row2) => (row1[col] > row2[col]) ? -1 : (row1[col] < row2[col]) ? 1 : 0)

  //   setTabData([...sortedData]);
  // };

  const editFormContentChange = (e) => {
    const { name, value } = e.target;
    setSelectedOneRowForEdit({ ...selectedOneRowForEdit, [name]: value });
  };

  const onUpdateConfirm = () => {
    let tempUpdatedData = tabData.map((item) =>
      item[uniqueId] === selectedOneRowForEdit[uniqueId]
        ? selectedOneRowForEdit
        : item
    );

    let tempDataArray = [];
    for (let index = pageStartIndex; index <= pageEndIndex; index++) {
      tempDataArray.push(tempUpdatedData[index]);
    }
    setDatainPage(tempDataArray);

    setSelectedOneRowForEdit(null);
  };

  const onUpdateCancel = () => {
    setSelectedOneRowForEdit(null);
  };

  const onDeleteConfirm = (selectedRow) => {
    // console.log(selectedRow, tabData)
    let tempRowData = tabData.filter(
      (row) => row[uniqueId] !== selectedRow[uniqueId]
    );
    setTabData(tempRowData);

    let tempDataArray = [];
    for (let index = pageStartIndex; index <= pageEndIndex; index++) {
      tempDataArray.push(tempRowData[index]);
    }
    setDatainPage(tempDataArray);

    // recordSelectionPerPageChange(recordsPerPage)
    setSelectedOneRowForDelete(null);
  };

  const onDeleteCancel = () => {
    setSelectedOneRowForDelete(null);
  };

  const editRow = (selectedOneRow) => {
    // EditOneRowPopUp
    // call edit popup form here
    console.log(selectedOneRow);
    setSelectedOneRowForEdit(selectedOneRow);
  };

  const deleteRow = (selectedOneRow) => {
    // Call confirmation popup here
    // DeleteOneRowPopUp
    setSelectedOneRowForDelete(selectedOneRow);
    console.log(selectedOneRow);
  };

  const changePage = (next) => {
    let page = next
      ? pageNo + 1 > pages
        ? pages
        : pageNo + 1
      : pageNo - 1 < 1
      ? 1
      : pageNo - 1;

    let start = Math.max((page - 1) * recordsPerPage, 0);
    let end = Math.min(page * recordsPerPage - 1, tabData.length - 1);

    console.log(start, end, pages, page);
    console.log(tabData.length);
    let tempDataArray = [];
    for (let index = start; index <= end; index++) {
      tempDataArray.push(tabData[index]);
    }

    setPageNo(page);
    setPageStartIndex(start);
    setPageEndIndex(end);
    setDatainPage(tempDataArray);
  };

  const sortColumn = (col, asc) => {
    if (asc) {
      setSortedAsc(1);
    } else {
      setSortedAsc(-1);
    }

    if (sortedColumn !== col) {
      setSortedAsc(1);
      setSortedColumn(col);
    }
    let sortedData = asc
      ? data.sort((row1, row2) =>
          row1[col] > row2[col] ? 1 : row1[col] < row2[col] ? -1 : 0
        )
      : data.sort((row1, row2) =>
          row1[col] > row2[col] ? -1 : row1[col] < row2[col] ? 1 : 0
        );

    setTabData([...sortedData]);

    console.log(sortedData, pageStartIndex, pageEndIndex);
    let tempDataArray = [];
    for (let index = pageStartIndex; index <= pageEndIndex; index++) {
      tempDataArray.push(sortedData[index]);
    }

    console.log(tempDataArray, pageStartIndex, pageEndIndex);

    setDatainPage(tempDataArray);
  };

  const recordSelectionPerPageChange = (noOfRecords) => {
    let start = 0;
    let end = Math.min(noOfRecords - 1, tabData.length - 1);

    let tempDataArray = [];
    for (let index = start; index <= end; index++) {
      tempDataArray.push(tabData[index]);
    }

    setPageStartIndex(start);
    setPageEndIndex(end);
    setRecordsPerPage(noOfRecords);
    // setPages(Math.ceil(data.length / noOfRecords));
    setPageNo(1);
    setDatainPage(tempDataArray);
  };

  return (
    <div className={AllOneTable.MainBody}>
      <div className={AllOneTable.frame}>
        <>
          {selectedOneRowForEdit && (
            <div className={AllOneTable.modal}>
              <div className={AllOneTable.modalcontent}>
                <h3 className={AllOneTable.PopupHeader}>Popup Form</h3>
                <div className={AllOneTable.Tdata}>
                  {columns.map((col, index) =>
                    getInputBoxFromType(
                      col,
                      selectedOneRowForEdit,
                      editFormContentChange,
                      index
                    )
                  )}
                </div>
                <div className={AllOneTable.PopupFooter}>
                  <button
                    className={AllOneTable.button33}
                    onClick={() => onUpdateConfirm()}
                  >
                    Update
                  </button>
                  <button
                    className={AllOneTable.button34}
                    onClick={() => onUpdateCancel()}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          )}
        </>

        <>
          {selectedOneRowForDelete && (
            <div className={AllOneTable.modal}>
              <div className={AllOneTable.modalcontent}>
                Popup Delete , Are you sure want to delete id :{" "}
                {selectedOneRowForDelete[uniqueId]}
                <button
                  onClick={() => onDeleteConfirm(selectedOneRowForDelete)}
                >
                  Delete
                </button>
                <button onClick={() => onDeleteCancel(selectedOneRowForDelete)}>
                  Cancel
                </button>
              </div>
            </div>
          )}
        </>

        {tableHeader && (
          <h2 className={AllOneTable.MainHeader}>{tableHeader}</h2>
        )}
        <table>
          <tr>
            {columns.map((col, index) => (
              <th>
                {col.sortable ? (
                  <button
                    className={AllOneTable.TableHeaderText}
                    onClick={() =>
                      sortColumn(
                        col.column,
                        sortedColumn === col.column && sortedAsc === 1
                          ? false
                          : true
                      )
                    }
                  >
                    {col.column}{" "}
                    {col.column === sortedColumn && (
                      <span>
                        {sortedAsc === -1 && <i>&#8595;</i>}
                        {sortedAsc === 1 && <i>&#8593;</i>}
                      </span>
                    )}
                  </button>
                ) : (
                  col.column
                )}
              </th>
            ))}
            <th className={AllOneTable.TableHeaderText}>Edit</th>
            <th className={AllOneTable.TableHeaderText}>Delete</th>
          </tr>

          <tr>
            {columns &&
              valuesToBeFiltered &&
              columns.map((col, index) => (
                <th className={AllOneTable.FilterSection}>
                  {col.filterable ? (
                    <input
                      className={AllOneTable.FilterInput}
                      placeholder={col.column}
                      value={valuesToBeFiltered[col.column]}
                      name={col.column}
                      onChange={(e) => changeFilterableInputs(e)}
                    />
                  ) : (
                    <input disabled />
                  )}
                </th>
              ))}
            <th></th>
            <th></th>
          </tr>

          {datainPage &&
            datainPage.map((row) => {
              return (
                <tr>
                  {columns.map((col) => (
                    <td>{row[col.column]}</td>
                  ))}
                  <td>
                    <button
                      className={AllOneTable.Editbtn}
                      onClick={() => editRow(row)}
                    >
                      {" "}
                      <FaEdit />
                    </button>
                  </td>

                  <td>
                    <button
                      className={AllOneTable.delbtn}
                      onClick={() => deleteRow(row)}
                    >
                      <FaPrescriptionBottleAlt />
                    </button>
                  </td>
                </tr>
              );
            })}
        </table>

        <div className={AllOneTable.TablePagination}>
          <button
            className={AllOneTable.PreNext_btn}
            onClick={() => changePage(false)}
          >
            &lt;
          </button>
          <span className={AllOneTable.PageNo}>{pageNo}</span>
          <button
            className={AllOneTable.PreNext_btn}
            onClick={() => changePage(true)}
          >
            &#62;
          </button>
          <select
            name="recordsPerPage"
            className={AllOneTable.PageOption}
            onChange={(e) => recordSelectionPerPageChange(e.target.value)}
            value={recordsPerPage}
          >
            {recordsPerPageOption.map((item) => (
              <option value={item}>{item}</option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default SortFilterEdit;
